export const abc = {
  select: {
    
 
    
  },
  option: {
   
  },
};

export const abcd = {
  select: {
    // backgroundColor: "white",
    // minHeight: "fit-content",
    //  borderRadius: "10px",
    // padding: "15px 20px",
    // maxWidth: "220px",
    // fontSize: "14px",
    // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    // border: "1px solid #e0e0e0",
    // color: "#333",
  },
  option: {
    // backgroundColor: "#ef5443",
    // marginBottom:"1px",
    // fontSize: "14px",
    
  },
 
};
